import React, { useState } from 'react'
import {Backdrop, Chip, Fade, Popper, useMediaQuery} from '@mui/material'
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined'
import SwipeableDrawer from "@mui/material/SwipeableDrawer"
import Card from "@mui/material/Card"
import FilterPanel from './FilterPanel'
import CounterLabel from '../../../shared/UI/CounterLable/CounterLabel'
import ButtonSmall from "../../../shared/UI/ButtonSmall"
import {filterBtnStyles} from "../../MyActions/MyActionsFilter/Styles"
import actionsService from '../../../services/actionsService'

const desktopCardWidth = '300px'

interface FilterProps {
  requestsCount: number
  disabled: boolean
}

function EnhancementsFilter(filterProps: FilterProps) {
  const { requestsCount, disabled } = filterProps
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const isMobile = useMediaQuery('(max-width:600px)')

  const handleOpen = (event: unknown) => {
    if (event instanceof Object && 'currentTarget' in event) {
      actionsService.userAnalytics
        .postEvent('UIClickEvent', 'EnhancementsFiltersButtonClick', window.location.pathname, window.location.hostname)
        .catch((error: unknown) => console.error('Analytics tracking error:', error))
      setAnchorEl(event.currentTarget as HTMLElement)
      setOpen(true)
    }
  }

  const handleClose = () => {
    setOpen(false)
    setAnchorEl(null)
  }


  const totalFilteredItems = (
    <Chip
      color="primary"
      variant="filled"
      data-testid="request-count"
      label={<CounterLabel count={requestsCount} />}
      size="small"
      sx={filterBtnStyles}
    />
  )

  return (
    <div>
      <ButtonSmall
        label="Filters"
        variant="outlined"
        onClick={handleOpen}
        startIcon={<FilterAltOutlinedIcon />}
        sx={{ margin: 0, mb: 2, p: '7px', minWidth: '120px' }}
        endIcon={totalFilteredItems}
        disabled={disabled}
      />

      {isMobile ? (
        <SwipeableDrawer
          anchor="bottom"
          open={open}
          onClose={handleClose}
          onOpen={() => setOpen(true)}
          PaperProps={{ sx: { maxHeight: 'calc(100% - 80px)' } }}
        >
          <div style={{ overflowY: 'scroll' }}>
            <FilterPanel {...filterProps} handleClose={handleClose} />
          </div>
        </SwipeableDrawer>
        ) : (
          <>
            <Backdrop
              open={open}
              onClick={handleClose}
              sx={{
                zIndex: 1,
                opacity: 0.2,
                backgroundColor: 'transparent',
                boxShadow: 'none',
              }}
            />
            <Popper
              open={open}
              anchorEl={anchorEl} 
              placement="bottom-start" 
              sx={{ mt: 1, zIndex: 2 }}
              modifiers={[{ name: 'offset', options: { offset: [0, 10] } }]}
              transition
            >
              {({ TransitionProps }) => (
                <Fade {...TransitionProps} timeout={500}>
                  <Card sx={{ maxWidth: desktopCardWidth }}>
                    <FilterPanel {...filterProps} handleClose={handleClose} />
                  </Card>
                </Fade>
              )}
            </Popper>
          </>
        )}
    </div>
  )
}
export default EnhancementsFilter